import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ArtInCoffeeTokenService } from '../../services/art-in-coffee-token.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-aic-token-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    ProgressSpinnerModule,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './aic-token-modal.component.html',
  styleUrl: './aic-token-modal.component.scss',
})
export class AicTokenModalComponent implements OnChanges {
  @Input() visible = false;
  @Input() userId = '';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() tokenSaved = new EventEmitter<void>();

  token = '';
  loading = false;
  saving = false;
  errorMessage = '';

  constructor(
    private aicTokenService: ArtInCoffeeTokenService, 
    private messageService: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible && this.userId) {
      this.fetchToken();
    }
  }

  fetchToken(): void {
    this.loading = true;
    this.errorMessage = '';
    this.token = '';

    this.aicTokenService.getToken(this.userId).subscribe({
      next: (response: any) => {
        this.token = typeof response === 'string' ? response : (response?.body ?? response?.data ?? '');
        this.loading = false;
      },
      error: (err: any) => {
        if (err.status === 404) {
          this.token = '';
        } else {
          this.errorMessage = 'Failed to load token. Please try again.';
        }
        this.loading = false;
      },
    });
  }

  saveToken(): void {
    if (!this.userId) return;
    this.saving = true;
    this.errorMessage = '';
    this.aicTokenService.upsertToken(this.userId, this.token).subscribe({
      next: () => {
        this.saving = false;
        this.close();
        this.tokenSaved.emit();
        this.messageService.add(
            {
                severity: 'success',
                summary: 'Success',
                detail: 'AIC Token edited successfully.'
            });
      },
      error: (err: any) => {
        this.saving = false;
        this.errorMessage = 'Failed to save token. Please try again.';
      },
    });
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.errorMessage = '';
  }

  onDialogHide(): void {
    this.visibleChange.emit(false);
    this.errorMessage = '';
  }
}
